module.exports = __webpack_public_path__ + "static/media/loyalty-rewards-program.012e4dd2.pdf";